<template>
  <v-container fluid grid-list-lg>
    <v-layout wrap>
      <v-flex xs12 sm10 lg8>
        <v-card>
          <v-toolbar color="indigo" dark dense>
            <v-toolbar-title>{{ label }}</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn :outlined="verAnulados" small @click="toggleVerAnulados">
              {{ verAnulados ? 'Ocultar Anulados' : 'Ver Anulados' }}
            </v-btn>
            <v-btn icon @click="addChild">
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-list>
            <v-list-item
              v-for="telefono in telefonosMostrados"
              :key="telefono.id"
            >
              <app-telefono-completo
                :value="telefono"
                :modoGestion="modoGestion"
                ref="hijos"
                v-on:update-telefonos="updateTelefonos"
                v-on:cancelar-ingreso="cancelarIngreso($event)"
                v-on:generar-contacto="generarContacto($event)"
              ></app-telefono-completo>
            </v-list-item>
          </v-list>
          <v-card-actions>
            <span v-if="modoGestion" class="text-xs-left caption"
              >(*) Presione en el ícono
              <v-icon color="green">perm_phone_msg</v-icon> para generar el
              contacto
            </span>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';

export default {
  data: () => ({
    loading: false,
    telefonosTodos: [],
    telefonos: [],
    telefonoEditor: {},
    verAnulados: false,
  }),
  props: {
    value: {
      type: Object,
      required: false,
    },
    propName: {
      type: String,
      required: false,
      default: 'telefonos',
    },
    label: {
      type: String,
      default: 'Teléfonos',
    },
    iconName: {
      type: String,
      default: 'phone',
    },
    modoGestion: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    'value.telefonos': function(item) {
      Vue.$log.debug('MANEJO TELEFONOS');
      Vue.$log.debug(item);
      this.telefonos = item;
      this.setTelefonos();
    },
  },
  computed: {
    telefonosMostrados: function() {
      if (!this.telefonos || this.telefonos.length == 0) return [];

      if (this.verAnulados) return this.telefonos;
      else return this.telefonos.filter((tel) => !tel.anulado);
    },
  },
  created() {
    // cargo el modelo
    if (this.value) this.setTelefonos();
  },
  methods: {
    setTelefonos() {
      if (!this.value[this.propName]) {
        // Si el telefono no está cargado, creo la propiedad
        this.telefonos = [];

        this.value[this.propName] = this.telefonos;
      }
      this.telefonos = this.value[this.propName];

      //this.telefonos.sort((a,b) => (a.orden - b.orden));
    },
    async addChild() {
      const res = await this.$dialog.confirm({
        text: '¿Está seguro que quiere agregar un teléfono?',
        title: 'Confirmar Operación',
        persistent: true, // Parece que no funciona...
      });

      if (!res) {
        return;
      }

      var maximoOrden = 0; // Busco el último orden que hay
      for (let index = 0; index < this.telefonos.length; index++) {
        if (this.telefonos[index].orden > maximoOrden)
          maximoOrden = this.telefonos[index].orden;
      }

      Vue.$log.debug(this.telefonos);
      //todo: al agregar telefonos, traer datos predeterminados (por ejemplo el prefijo en base a la sucursal, etc)

      var nuevoTelefono = {
        prefijo: '',
        numero: '',
        interno: '',
        horario: '',
        comentarios: '',
        contactosPositivos: 0,
        contactos: 0,
        perteneceA: { id: 1 },
        esCelular: true,
        esLaboral: false,
        anulado: false,
        //orden: ultimoOrden + 1
        orden: maximoOrden + 1,
      };

      Vue.$log.debug(maximoOrden);
      Vue.$log.debug(nuevoTelefono);

      if (this.telefonos.length > 0) {
        // si ya hay algún otro telefono, copio el prefijo del primero
        nuevoTelefono.provincia = this.telefonos[0].provincia;
        nuevoTelefono.partido = this.telefonos[0].partido;
        nuevoTelefono.localidad = this.telefonos[0].localidad;
        nuevoTelefono.codigoPostal = this.telefonos[0].codigoPostal;
      }

      this.telefonos.push(nuevoTelefono);

      Vue.nextTick(() => {
        // esto es para esperar a que se renderice el componente nuevo
        this.$refs.hijos.find(
          (ref) => ref.telefono.orden == nuevoTelefono.orden
        ).editModeOn = true;
      });
    },
    async deleteChild(telefonoAEliminar) {
      const res = await this.$dialog.confirm({
        text: '¿Confirma la eliminación del Teléfono?',
        title: 'Confirmar Operación',
        persistent: true, // Parece que no funciona...
      });

      if (res) {
        var indiceAEliminar = -1;
        for (let index = 0; index < this.telefonos.length; index++) {
          if (this.telefonos[index].orden == telefonoAEliminar.orden) {
            indiceAEliminar = index;
            break;
          }
        }

        //Vue.$log.debug(indiceAEliminar);

        if (indiceAEliminar >= 0) {
          this.telefonos.splice(indiceAEliminar, 1);
        }
      }
    },
    updateTelefonos() {
      this.$emit('update-telefonos');
    },
    generarContacto(telefono) {
      Vue.$log.debug(telefono);
      this.$emit('generar-contacto', telefono);
    },
    cancelarIngreso(ordenAEliminar) {
      var indiceAEliminar = -1;

      for (let index = 0; index < this.telefonos.length; index++) {
        if (this.telefonos[index].orden == ordenAEliminar) {
          indiceAEliminar = index;
          break;
        }
      }
      if (indiceAEliminar >= 0) {
        this.telefonos.splice(indiceAEliminar, 1);
      }
    },
    toggleVerAnulados() {
      this.verAnulados = !this.verAnulados;
    },
  },
};
</script>

<style></style>
